module.exports = __webpack_public_path__ + "img/1.f287f17a.png";